import { Component, OnInit } from '@angular/core';
import { NavigationDrawerService } from '@ffq-app-shared/components';
import { AppStoreService } from '@ffq-app-store/app.store.service';
import { ServiceConstants } from '@ffq-app-shared/constants/service.constants';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-auto-quote-page',
  templateUrl: './auto-quote-page.component.html',
  styleUrls: ['./auto-quote-page.component.scss']
})
export class AutoQuoteComponent implements OnInit {
  quoteNumber: any;
  pageTitle = 'We’re sorry';
  desktopNo: string;
  mobileNo: string;
  teleDesktop: string;
  teleMobile: string;
  desktopAriaLlabel: string;
  mobileAriaLlabel: string;
  sourcePhoneNumber: string;
  /**
   * Heading  of auto quote component
   */
  heading: string;
  /**
   * Sub heading of auto quote component
   */
  subHeading: string;

  constructor(private navDrawer: NavigationDrawerService,
              private appStoreService: AppStoreService,
              private titleService: Title
  ) { }

  ngOnInit() {
    this.setTitle(this.pageTitle);
    this.navDrawer.hideDrawer();
    this.navDrawer.hideEverything();
    this.appStoreService.getPhoneNumberFromSrc$.subscribe((phoneNumber: any) => {
      this.sourcePhoneNumber = phoneNumber;
      this.setAgentPhoneNumber();
    });
    // Changes for the showing text mesages maintaince page
    this.appStoreService.appError$.subscribe((errorObj: any) => {
      if (errorObj && Object.keys(errorObj).length !== 0) {
        this.heading = errorObj.errorInfo.headerContent;
        this.subHeading = errorObj.errorInfo.displayContent;
      }
    });
  }

  findAnAgent() {
    window.location.href = ServiceConstants.FIND_AN_AGENT;
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  /**
   * Sets agent phone number
   */
  setAgentPhoneNumber() {
    if (this.sourcePhoneNumber) {
      this.teleDesktop = this.teleMobile = 'tel:' + this.sourcePhoneNumber.replace(/-/g, '');
      this.desktopNo = this.mobileNo = this.sourcePhoneNumber;
      this.desktopAriaLlabel = this.mobileAriaLlabel = this.sourcePhoneNumber + ' link';
    } else {
      this.teleDesktop = 'tel:18002069469';
      this.teleMobile = 'tel:18004209008';
      this.desktopNo = '1-800-206-9469';
      this.mobileNo = '1-800-206-9469';
      this.desktopAriaLlabel = '1-800-206-9469 link';
      this.mobileAriaLlabel = '1-800-206-9469 link';
    }
  }
}
